import Vapi from 'vuex-rest-api'

const API = new Vapi({
  state: {
    form: [],
    capsules: []
  }
})

  // FORMS
  .get({
    action: 'getForm',
    path: 'testFormsBasic?name=msteam-capsule',
    property: 'form'
  })
  // CRUD files

  .post({
    action: 'getCapsuleFiles',
    path: ({ id }) => 'api/data/getFile/projects'
  })
  .post({
    action: 'deleteFile',
    path: 'api/data/deleteFile/projects'
  })
  .post({
    action: 'downloadFile',
    path: 'api/data/download/projects'
  })

  // CRUD capsules
  .get({
    action: 'getCapsule',
    path: ({ id }) => `api/data/projects/get/${id}`,
    property: 'capsule'
  })

  .post({
    action: 'getCapsules',
    path: 'api/data/projects/get',
    property: 'capsules'
  })

  .post({
    action: 'createCapsule',
    path: 'api/data/projects/new',
    property: 'createCapsule'
  })

  .post({
    action: 'updateCapsule',
    path: 'api/data/projects/update',
    property: 'updateCapsule'
  })

  .post({
    action: 'deleteCapsule',
    path: 'api/data/projects/delete'
  })

  // CRUD sections
  .get({
    action: 'getSection',
    path: ({ id }) => `api/data/pageSections/get/${id}`,
    property: 'section'
  })

  .post({
    action: 'getSections',
    path: 'api/data/pageSections/get',
    property: 'sections'
  })

  .post({
    action: 'createSection',
    path: ({ type }) => `api/data/${type}s/new`,
    property: 'createSection'
  })

  .post({
    action: 'updateSection',
    path: ({ type }) => `api/data/${type}s/update`,
    property: 'updateSection'
  })

  .post({
    action: 'deleteSection',
    path: 'api/data/pageSections/delete'
  })
  .post({
    action: 'deleteSectionItem',
    path: 'api/data/pageSectionElements/delete'
  })
  // session management
  .get({
    action: 'checkSession',
    path: 'checkSession'
    // path: process.env.VUE_APP_OAUTH_AUTH_URL,
    // queryParams: true
  })
  // STATS
  .post({
    action: 'getStats',
    path: '/api/stats/get'
  })
  .post({
    action: 'registerStats',
    path: '/api/stats/create'
  })
  .get({
    action: 'fetchActivityStats',
    path: '/api/V2/stats/activity'
  })
  .get({
    action: 'fetchDownloadStats',
    path: '/api/V2/stats/downloads'
  })

  .getStore()

export default API
